
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="searchMember($event)" placeholder="શોધો.." />
                <i class="ti ti-search"></i>
            </form>
        </div>
    </div>
    <div class="main-members">
        <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
            <!-- <mat-tab label="કાર્યકર્તા સભ્યો">
            <div class="main-members family-tabs">
          <a *ngFor="let member of activistListData" class="member-list-item">
                    <ng-container [ngSwitch]="member.image !== ''">
                        <img *ngSwitchCase="true" [src]="baseUrl + member.image" />
                        <img *ngSwitchCase="false" src="../../../assets/img/user_.jpg" />
                    </ng-container>
                    <div>
                        <h5>{{ member.name }}</h5>
                        <p>{{ member.contact_no }} | {{ member.gender }}</p>
                    </div>                                   
                </a>
            </div>
        </mat-tab>  -->

            <mat-tab label="સભ્યો">
                <div class="main-members family-tabs">
                    <a *ngFor="let member of allMemberData" class="member-list-item">
                        <ng-container [ngSwitch]="member.image !== ''">
                            <img *ngSwitchCase="true" [src]="baseUrl + member.image" />
                            <img *ngSwitchCase="false" src="../../../assets/img/user_.jpg" />
                        </ng-container>
                        <div>
                            <h5>{{ member.name }}</h5>
                            <p>{{ member.contact_no }} </p>
                            <p>{{member.business}}<span *ngIf="member.business && member.village_name">|</span>
                                {{member.village_name }}</p>
                        </div>
                        <select #selectBox (change)="UpdateStatus(selectBox.value, member)" class="cursorClass">
                            <ng-container>
                                <option value="0" selected
                                    [selected]="member.user_type_id !== 2 && member.user_type_id !== 3 && member.user_type_id !== 4">
                                    સભ્યો</option>
                                <option value="2" [selected]="member.user_type_id == 2">કારોબારી કમિટી</option>
                                <option value="3" [selected]="member.user_type_id == 3">યુવા કમિટી</option>
                                <option value="4" [selected]="member.user_type_id == 4">સ્ટુડન્ટ કમિટી</option>
                            </ng-container>
                        </select>
                    </a>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</main>